/* eslint-disable no-useless-return */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-misused-promises */
import {CommonModule} from '@angular/common';
import {Component, OnDestroy, OnInit, NgZone} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ActivatedRoute, NavigationStart, Router, RouterOutlet} from '@angular/router';
import {SwUpdate} from '@angular/service-worker';
import {
  IonApp,
  IonContent,
  IonProgressBar,
  IonRouterOutlet,
  IonSplitPane,
} from '@ionic/angular/standalone';
import {addIcons} from 'ionicons';
import {
  addOutline,
  alertCircleOutline,
  arrowBackOutline,
  calendarOutline,
  call,
  checkmarkCircleOutline,
  chevronBackOutline,
  chevronDownOutline,
  chevronForwardOutline,
  closeOutline,
  documentAttachOutline,
  helpCircleOutline,
  logOutOutline,
  newspaperOutline,
  notificationsOutline,
  playCircleOutline,
  refreshOutline,
  warningOutline,
} from 'ionicons/icons';
import {BaseComponent} from './core/component/base/base.component';
import AppConstant from './shared/constants/app.constant';
import {RouteEnum} from './shared/constants/route.enum';
import {DateService} from './shared/service/date/date.service';
import {InstallService} from './shared/service/install/install.service';
import {LoaderService} from './shared/service/loader/loader.service';
import {AppStorageService} from './shared/service/storage/app-storage.service';
import appUtil from './shared/util/app.util';
import {AppStoreService} from './store/app-store.service';
import {NetworkStatusService} from './shared/service/network-status/network-status.service';
import {AppEnum} from './shared/constants/app.enum';
import {ToastService} from './shared/service/toast/toast.service';
import {WebexService} from './shared/service/webex/webex.service';
import {AppPrincipalService} from './shared/service/principal/app-principal.service';
import {App, URLOpenListenerEvent} from '@capacitor/app';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [
    IonProgressBar,
    RouterOutlet,
    IonApp,
    IonSplitPane,
    CommonModule,
    IonContent,
    IonProgressBar,
  ],
})
export class AppComponent extends BaseComponent implements OnInit, OnDestroy {
  deferredPrompt: any;

  constructor(
    private readonly router: Router,
    private readonly appStore: AppStoreService,
    public loadingService: LoaderService,
    private readonly swUpdate: SwUpdate,
    private readonly appInstallSvc: InstallService,
    private readonly appStorageSvc: AppStorageService,
    private readonly nwStatusSvc: NetworkStatusService,
    private readonly toast: ToastService,
    private readonly webexSvc: WebexService,
    private readonly dateSvc: DateService,
    private readonly principalSvc: AppPrincipalService,
    private readonly zone: NgZone
  ) {
    super();
    addIcons({
      checkmarkCircleOutline,
      warningOutline,
      alertCircleOutline,
      closeOutline,
      refreshOutline,
      chevronBackOutline,
      chevronForwardOutline,
      chevronDownOutline,
      newspaperOutline,
      calendarOutline,
      documentAttachOutline,
      playCircleOutline,
      helpCircleOutline,
      logOutOutline,
      arrowBackOutline,
      addOutline,
      notificationsOutline,
      call,
    });
  }

  ngOnInit(): void {
    this.handleLandingPage();
    this.getCurrentActiveUrl();
    this.handleAppVersionUpdate();
    this.addNetWorkStatusListener();
    this.setupDeepLinkListener();
    // this.promptInstall();
  }

  private setupDeepLinkListener(): void {
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      console.log('Deep link received:', event.url);

      // Handle OAuth callback from Webex
      const url = event.url;
      if (url.includes('oauth/callback')) {
        // Extract access token from URL hash
        const hashIndex = url.indexOf('#');
        if (hashIndex !== -1) {
          const hashParams = new URLSearchParams(url.substring(hashIndex + 1));
          const accessToken = hashParams.get('access_token');

          if (accessToken) {
            console.log('Access token received from deep link');

            // Store the access token
            this.appStorageSvc.setItem(AppConstant.STORAGE_KEYS.SIT_WBX_TKN, accessToken);

            // Initialize Webex with the stored token
            void this.webexSvc.init();

            // Use NgZone to ensure navigation happens within Angular's zone
            this.zone.run(() => {
              // Navigate to dealer meeting page if user is already authenticated
              const token = this.appStorageSvc.getItem(AppConstant.STORAGE_KEYS.SIT_T);
              if (token) {
                // User is logged in, navigate to dealer meeting
                const startDate = this.dateSvc.moment().format('DD-MMM-YYYY');
                void this.router.navigate([
                  `${RouteEnum.DELAER_MEETING_BASE_ROUTE_PATH}/${startDate}`,
                ]);
              } else {
                // Still on login screen, do nothing - let verify OTP complete
                console.log('Webex token stored, waiting for login completion');
              }
            });
          }
        }
      }
    });
  }

  private addNetWorkStatusListener(): void {
    window.addEventListener('online', () => {
      void this.toast.show({
        message: AppConstant.TOST_MSG.APP_ONLINE,
        color: 'success',
      });
      this.updateNwStatus(AppEnum.NW_ONLINE);
    });
    window.addEventListener('offline', () => {
      void this.toast.show({
        message: AppConstant.TOST_MSG.APP_OFFLINE,
        color: 'danger',
      });
      this.updateNwStatus(AppEnum.NW_OFFLINE);
    });
  }

  private updateNwStatus(status: string): void {
    this.nwStatusSvc.updateOnlineStatus(status);
  }

  private async handleLandingPage(): Promise<void> {
    if (this.isDealer() || this.isBaseUrl()) {
      await this.webexSvc.loadWebexSDK();
      await this.handleDealerNavigation();
    } else {
      await this.navigateDefault();
    }
  }

  private async handleDealerNavigation(): Promise<void> {
    if (!appUtil.isEmpty(this.appStorageSvc.getItem(AppConstant.STORAGE_KEYS.SIT_T))) {
      if (this.isBaseUrlOrWbx()) {
        this.handleWebexRedirection();
        if (this.webexSvc.isDelaerLoggedInToWebEx()) {
          const startDate = this.dateSvc.moment().format('DD-MMM-YYYY');
          await this.router.navigateByUrl(
            `${RouteEnum.DELAER_MEETING_BASE_ROUTE_PATH}/${startDate}`
          );
        } else {
          this.authentiCateWebExIfNotDone();
        }
      } else if (this.isDealer()) {
        await this.authentiCateWebExIfNotDone();
        await this.navigateDefault();
      } else {
        await this.navigateDealerDefault();
      }
    } else {
      await this.navigateDealerDefault();
    }
  }

  private handleWebexRedirection(): void {
    const webExToken = this.isRedirectedFromWbx(location.href);
    if (webExToken) {
      this.appStorageSvc.setItem(AppConstant.STORAGE_KEYS.SIT_WBX_TKN, webExToken);
    }
  }

  async authentiCateWebExIfNotDone(): Promise<any> {
    const webexToken = this.appStorageSvc.getItem(AppConstant.STORAGE_KEYS.SIT_WBX_TKN);
    if (appUtil.isEmpty(webexToken)) {
      this.webexSvc.init();
      const webex = this.webexSvc.getWebex();
      await webex?.authorization?.initiateLogin();
      return;
    }
  }

  private async navigateDealerDefault(): Promise<void> {
    await this.router.navigateByUrl(`${RouteEnum.DELAER_BASE_LOGIN_URL}`);
  }

  private async navigateDefault(): Promise<void> {
    await this.router.navigateByUrl(`${location.pathname}${location.search}`);
  }

  private isDealer(): boolean {
    // TODO
    const isDealer = location.pathname.startsWith('/dealer/');
    this.appStore.updatePartialState('isDealer', isDealer);
    return isDealer;
  }

  private isBaseUrlOrWbx(): boolean {
    return (
      this.isBaseUrl() ||
      location.href?.includes(`/#${AppConstant.WBX_T_KEY}`) ||
      location.pathname === '/dealer/login'
    );
  }

  private isBaseUrl(): boolean {
    return location.pathname === '/';
  }

  private isRedirectedFromWbx(href: string): string | null {
    const fragment = new URL(href)?.hash?.substring(1);
    const params = new URLSearchParams(fragment);
    const wbx_t = params.get(AppConstant.WBX_T_KEY);
    return wbx_t ?? null;
  }

  private promptInstall(): void {
    window.addEventListener('beforeinstallprompt', async event => {
      // Prevent Chrome 76 and earlier from showing the prompt
      event.preventDefault();
      await this.appInstallSvc.showInstallPrompt(event);
    });
  }

  private getCurrentActiveUrl(): void {
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => {
      if (event instanceof NavigationStart) {
        console.log('route frm event###', event.url);
        this.appStore.updatePartialState('curentUrl', event.url);
      }
    });
  }

  private async handleAppVersionUpdate(): Promise<void> {
    this.swUpdate.versionUpdates.subscribe(async event => {
      console.log('Version Updated', event);
      if (event.type === 'VERSION_DETECTED') {
        console.log('App Deployed!!');
        // TODO: Experimental cache clear logic, needs to be looked upon
        // this.clearCache();
        // this.appStorage.clear();
        // await this.router.navigateByUrl(RouteEnum.DELAER_BASE_LOGIN_URL);
        // await this.appInstallSvc.updateAppVersion();
        // window.location.reload();
      }
    });
  }

  async clearCache(): Promise<void> {
    if ('caches' in window) {
      caches.keys().then(cacheNames => {
        cacheNames.forEach(cacheName => {
          caches.delete(cacheName);
        });
        console.log('Cache cleared');
      });
    }
  }

  ngOnDestroy(): void {
    // clean up listener once app component is destroyed
    window.removeEventListener('online', () => {
      this.updateNwStatus(AppEnum.NW_ONLINE);
    });
    window.removeEventListener('offline', () => {
      this.updateNwStatus(AppEnum.NW_OFFLINE);
    });
  }
}
